import React from 'react';
import BadgeTier from './SellerBadge';

/**
 * VerifiedUserBadge — thin backwards-compatible wrapper over the unified
 * `<BadgeTier tier="user">` from SellerBadge.js.
 *
 * iter121 — Blue shield (#2563eb), title "Verified User". Same shape as
 * Trusted Seller + Trusted Dealer.
 */
const VerifiedUserBadge = ({ size = 'sm', className }) => (
  <BadgeTier tier="user" size={size} />
);

export default VerifiedUserBadge;
